export enum BoostTypeId {
  JobContent = 1,
  SparkCode = 2,
  GetContent = 3,
}
